<template>
  <div
    class="compare-selector"
    :class="{ 'compare-selector--invalid': !isValidModel, 'compare-selector--windows': isWindows }"
  >
    <Select
      :id="`${id}`"
      class="compare-selector__select"
      :theme="theme"
      :value.sync="currentValue"
      :options="selectOptions"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import Select from '@/components/_shared/Form/Select/Select.vue'
import { SPECS_PRODUCT_TYPES, SPECS_MODELS } from '../constants'

export default {
  name: 'CompareSelector',
  components: { Select },
  props: {
    id: {
      type: Number,
      required: true,
    },
    initialValue: {
      type: String,
      default: '',
    },
    defaultOptionText: {
      type: String,
      default: '...',
    },
    disabledOptionValue: {
      type: String,
      default: '',
    },
    productType: {
      type: String,
      default: SPECS_PRODUCT_TYPES.shoes,
    },
    theme: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      currentValue: '',
      SPECS_MODELS,
      SPECS_PRODUCT_TYPES,
    }
  },

  computed: {
    ...mapGetters({
      isWindows: 'page/isWindows',
    }),

    optionsFromType() {
      return SPECS_MODELS[this.productType]
    },

    selectOptions() {
      const defaultOption = { text: this.defaultOptionText, value: '', disabled: true }
      const options = this.optionsFromType.map(option => ({
        ...option,
        disabled: option.value === this.disabledOptionValue,
      }))
      return [defaultOption, ...options]
    },

    isValidModel() {
      return (
        this.optionsFromType.some(option => option.value === this.initialValue) ||
        this.initialValue === ''
      )
    },
  },

  watch: {
    currentValue() {
      this.handleSelection()
    },
  },

  created() {
    this.currentValue = this.initialValue
  },

  methods: {
    handleSelection() {
      if (this.currentValue === this.initialValue) return

      this.$emit('select', {
        id: this.id,
        slug: this.currentValue,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.compare-selector {
  &--windows {
    /deep/ .select__field {
      color: $color-grey-mid-2;
    }
  }
}
</style>
